export default __webpack_public_path__ + "static/media/WorkImg.13ab843e.jpg";